import React from 'react';
import useLongPress from './longPress';
import cn from 'classnames';

const LongPressKds = (props) => {
  const {
    children,
    onClick,
    onLongPress,
    defaultOptions,
    className,
    disabled,
    style
  } = props;
  const longPressEvent = useLongPress(onLongPress, onClick, defaultOptions);

  return (
    <span
      {...longPressEvent}
      className={cn('w-100 position-relative', className)}
      disabled={disabled}
      style={style}
    >
      {children}
    </span>
  );
};

export default LongPressKds;
